import * as React from 'react';
var __REDI_CONTEXT_LOCK__ = 'REDI_CONTEXT_LOCK';
// eslint-disable-next-line node/prefer-global/process
var isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
var globalObject = (typeof globalThis !== 'undefined' && globalThis)
    || (typeof window !== 'undefined' && window)
    // eslint-disable-next-line no-restricted-globals
    || (typeof global !== 'undefined' && global);
if (!globalObject[__REDI_CONTEXT_LOCK__]) {
    globalObject[__REDI_CONTEXT_LOCK__] = true;
}
else if (!isNode) {
    console.error('[redi]: "RediContext" is already created. You may import "RediContext" from different paths. Use "import { RediContext } from \'@wendellhu/redi/react-bindings\'; instead."');
}
export var RediContext = React.createContext({
    injector: null,
});
RediContext.displayName = 'RediContext';
export var RediProvider = RediContext.Provider;
export var RediConsumer = RediContext.Consumer;
//# sourceMappingURL=reactContext.js.map